import { queryOptions } from '@tanstack/react-query'
import { lessonKeys } from './keys'
import { CACHE_TIMES } from './cache-config'
import { studentLessonsApi } from '@/lib/api/student-lessons'

export function resolveEntityQueryOptions(menu: string, program?: string, episode?: string) {
  return queryOptions({
    queryKey: lessonKeys.resolve(menu, program, episode),
    queryFn: async () => {
      const query: { menu: string; program?: string; episode?: string } = { menu }
      if (program) query.program = program
      if (episode) query.episode = episode
      const { data, error } = await studentLessonsApi().api.student.lessons.resolve.get({ query })
      if (error) throw error
      return data
    },
    staleTime: CACHE_TIMES.STALE_DETAIL,
    enabled: !!menu,
  })
}

export function lessonDetailQueryOptions(id: string) {
  return queryOptions({
    queryKey: lessonKeys.detail(id),
    queryFn: async () => {
      const { data, error } = await studentLessonsApi().api.student.lessons({ id }).get()
      if (error) throw error
      return data
    },
    staleTime: CACHE_TIMES.STALE_DETAIL,
    enabled: !!id,
  })
}

export function lessonContextQueryOptions(id: string) {
  return queryOptions({
    queryKey: lessonKeys.context(id),
    queryFn: async () => {
      const { data, error } = await studentLessonsApi().api.student.lessons({ id }).context.get()
      if (error) throw error
      return data
    },
    staleTime: CACHE_TIMES.STALE_DETAIL,
    enabled: !!id,
  })
}

export function courseTreeQueryOptions(lessonId: string) {
  return queryOptions({
    queryKey: lessonKeys.courseTree(lessonId),
    queryFn: async () => {
      const { data, error } = await studentLessonsApi().api.student.lessons({ id: lessonId }).course.get()
      if (error) throw error
      return data
    },
    staleTime: CACHE_TIMES.STALE_DETAIL,
    enabled: !!lessonId,
  })
}

export function lessonProgressQueryOptions(id: string) {
  return queryOptions({
    queryKey: lessonKeys.progress(id),
    queryFn: async () => {
      const { data, error } = await studentLessonsApi().api.student.lessons({ id }).progress.get()
      if (error) throw error
      return data
    },
    staleTime: CACHE_TIMES.STALE_REALTIME,
    enabled: !!id,
  })
}

export function courseProgressQueryOptions(lessonId: string) {
  return queryOptions({
    queryKey: lessonKeys.courseProgress(lessonId),
    queryFn: async () => {
      const { data, error } = await studentLessonsApi().api.student.lessons({ id: lessonId })['course-progress'].get()
      if (error) throw error
      return data
    },
    staleTime: CACHE_TIMES.STALE_DEFAULT,
    enabled: !!lessonId,
  })
}

export function lessonResourcesQueryOptions(id: string) {
  return queryOptions({
    queryKey: lessonKeys.resources(id),
    queryFn: async () => {
      const { data, error } = await studentLessonsApi().api.student.lessons({ id }).resources.get()
      if (error) throw error
      return data
    },
    staleTime: CACHE_TIMES.STALE_STATIC,
    enabled: !!id,
  })
}

export function lessonCommentsQueryOptions(id: string, params?: Record<string, unknown>) {
  return queryOptions({
    queryKey: lessonKeys.comments(id, params),
    queryFn: async () => {
      const { data, error } = await studentLessonsApi().api.student.lessons({ id }).comments.get({ query: params })
      if (error) throw error
      return data
    },
    staleTime: CACHE_TIMES.STALE_DEFAULT,
    enabled: !!id,
  })
}
